import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertAppUpdated(props) {

  return (
      <Dialog
        open={props.open}
        onClose={props.handleNo}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Mise à jour détectée"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Le site a été mis à jour. Il va être rechargé...
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { /* <Button onClick={props.handleNo}>Non</Button> */}
          <Button onClick={props.handleYes} autoFocus>Ok</Button>
        </DialogActions>
      </Dialog>
  );
}